import useI18nStore from "../Store";

import type { Language } from "@/Common/Models/Domain/Language";

import { getAllLocalesInfo } from "@/Services/TherapyApi/Translations";

import { isValidString } from "@/Utils/String";
import { hasValue } from "@/Utils/Objects";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

async function CheckLocaleVersionActionHandler(locale?: Language): Promise<boolean> {
  // Return true if the locale version is greater than the local version
  const i18nStore = useI18nStore();
  const localeToCheck = locale ?? i18nStore.locale;

  if (isValidString(localeToCheck)) {
    const translationsResp = await getAllLocalesInfo();

    if (isApiError(translationsResp) || !hasValue(translationsResp) || translationsResp.length === 0) {
      return false;
    }

    const translationLocale = translationsResp.find(
      (translation) => translation.locale.trim().toUpperCase() === localeToCheck.trim().toUpperCase()
    );

    if (!hasValue(translationLocale)) {
      return false;
    }

    const version = translationLocale.version;
    const localVersion = i18nStore.locales.get(localeToCheck)?.version;

    if (hasValue(version) && hasValue(localVersion) && version > localVersion) {
      return true;
    }
  }

  return false;
}

export default CheckLocaleVersionActionHandler;
